enum DifficultyLevel {
    PRIMARY_1_2 = 'PRIMARY_1-2',
    PRIMARY_3_5 = 'PRIMARY_3-5',
    PRIMARY_6_8 = 'PRIMARY_6-8',
}

export default DifficultyLevel;
